import React from "react"
import PropTypes from "prop-types"
import styled from "styled-components"
import { graphql } from "gatsby"
import { connect } from "react-redux"
import { postJobParsing, getJobParsing } from "store/actions/job"
import { getSearchParams } from "gatsby-query-params";

import GlobalStateProvider from "context/provider"
import ContentWrapper from "styles/contentWrapper"
import Layout from "components/layout"
import SEO from "components/seo"
import Hero from "components/sections/category/hero"
import Clients from "components/sections/clients"
import Demos from "components/sections/category/demos"
import PrimaryCard from "components/common/primaryCard"
import Grid from "components/sections/grid"
import Breadcumbs from "components/common/breadcumbs"
import Parsing from "components/job/parsing"
import docImg from "content/images/search.svg"

const jobRevealingImg = "https://hrflow-ai.imgix.net/labs/job-imaging.webp?w=350&h=350&fit=clip"
const documentLinking = "https://hrflow-ai.imgix.net/labs/document-linking.png?w=350&h=350&fit=clip"
const textImagingImg = "https://hrflow-ai.imgix.net/labs/job-revealing.png?w=350&h=350&fit=clip"

const StyledGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  grid-gap: 2rem;
  margin-bottom: 2rem;
  @media (min-width: ${({ theme }) => theme.breakpoints.md}) {
    grid-template-columns: 1fr 1fr;
  }
`
const JobParsingPage = (
  {
    data,
    getJobParsing,
    jobParsing,
    postJobParsing,
    job,
  }) => {
  const { frontmatter } = data.index.edges[0].node
  const { seoTitle, useSeoTitleSuffix, useSplashScreen } = frontmatter
  const queryParams = getSearchParams()

  const globalState = {
    // if useSplashScreen=false, we skip the intro by setting isIntroDone=true
    isIntroDone: useSplashScreen ? false : true,
    // darkMode is initially disabled, a hook inside the Layout component
    // will check the user's preferences and switch to dark mode if needed
    darkMode: false,
  }


  return (
    <GlobalStateProvider initialState={globalState}>
      <Layout>
        <SEO
          frontmatter={frontmatter}
        />
        <Breadcumbs
          color="#9F7AEA"
          text="Text analysis"
          link="/text-analysis/"
          logo={docImg}
        />
        <Hero
          content={data.hero.edges}
          color="#9F7AEA"
          resultPage={queryParams?.key}
          docs="https://developers.hrflow.ai/reference/text-parsing-1"
          videoUrl="//www.youtube.com/embed/x9736REPAqs"
          videoText="Discover our Text Parsing tool with our Parsing API V3.0"
        />
        <Grid videoUrl="//www.youtube.com/embed/x9736REPAqs">
          <Parsing
            queryParams={queryParams}
            getJobParsing={getJobParsing}
            jobParsing={jobParsing}
            postJobParsing={postJobParsing}
            response={job}
          />
        </Grid>
        <Clients content={data.clients.edges} category />
        <Demos content={data.demos.edges}>
          <StyledGrid className="mt-2">
            {/* <PrimaryCard
              image={jobRevealingImg}
              color="#9F7AEA"
              title="Text Revealing"
              link="/text-analysis/revealing/"
              subtitle="Enter an unstructured text and predict the forgotten soft and hard skills."
            /> */}
            <PrimaryCard
              image={jobRevealingImg}
              color="#9F7AEA"
              title="Text Tagging"
              link="/text-analysis/tagging/"
              subtitle="Predict most likely tags for a text with our library of AI algorithms."
            />
            <PrimaryCard
              image={documentLinking}
              color="#9F7AEA"
              title="Text Linking"
              link="/text-analysis/linking/"
              subtitle="Enter a word and get its Top 10 closest words whether it is a person name, school, organization, skill, interest, country and more."
            />
            <PrimaryCard
              image={textImagingImg}
              color="#9F7AEA"
              title="Text Imaging"
              link="/text-analysis/imaging/"
              subtitle="Enter a job description to generate an image that showcases the tasks required from your future employees."
            />  
          </StyledGrid>
        </Demos>
      </Layout>
    </GlobalStateProvider>
  )
}

JobParsingPage.propTypes = {
  data: PropTypes.object.isRequired,
}

const mapStateToProps = state => ({
  job: state.job.job,
  jobParsing: state.job.jobParsing
})

export default connect(mapStateToProps, { postJobParsing, getJobParsing })(JobParsingPage)

export const pageQuery = graphql`
  {
    index: allMdx(filter: { fileAbsolutePath: { regex: "/job/parsing/index/" } }) {
      edges {
        node {
          frontmatter {
            seoTitle
            seoImage
            url
            description
            keywords
            useSeoTitleSuffix
            useSplashScreen
          }
        }
      }
    }
    hero: allMdx(filter: { fileAbsolutePath: { regex: "/job/parsing/hero/" } }) {
      edges {
        node {
          frontmatter {
            title
            description
          }
        }
      }
    }
    clients: allMdx(filter: { fileAbsolutePath: { regex: "/home/clients/" } }) {
      edges {
        node {
          exports {
            shownItems
            clients {
              alt
              logo {
                childImageSharp {
                  gatsbyImageData(layout: CONSTRAINED, width: 300, quality: 90, placeholder: NONE)
                }
              }
            }
          }
          frontmatter {
            title
          }
        }
      }
    }
    demos: allMdx(filter: { fileAbsolutePath: { regex: "/job/parsing/demos/" } }) {
      edges {
        node {
          frontmatter {
            label
            title
            titlePrefix
            description
          }
        }
      }
    }
  }
`